import React from 'react';
import { Button, Space } from 'antd';
import { ArrowLeftOutlined } from '@ant-design/icons';
import PropTypes from 'prop-types';
import { ICON } from './icon';

const MenuBar = ({
    isPreviewMode,
    setIsPreviewMode,
    setIsCustomize,
    state,
    dsBreachDetail,
    loading,
    onFinish,
    setOpenConfirm,
}) => {
    const items = isPreviewMode
        ? [
              {
                  label: 'กลับไปแก้ไข',
                  onClick: () => {
                      setIsCustomize(false);
                      setIsPreviewMode(!isPreviewMode);
                      state.SW.goToStep(1);
                  },
                  icon: <ArrowLeftOutlined />,
              },
          ]
        : [
              {
                  label: 'แสดงตัวอย่าง',
                  onClick: () => {
                      state.SW.goToStep(2);
                      setIsPreviewMode(!isPreviewMode);
                  },
                  icon: ICON[3],
              },

              {
                  label: 'ปรับแต่งธีม',
                  onClick: () => {
                      setIsPreviewMode(!isPreviewMode);

                      setIsCustomize(true);

                      state.SW.goToStep(2);
                  },
                  icon: ICON[4],
              },
          ];

    return (
        <div
            className="bg-white p-4 px-6 flex justify-between items-center mt-4 shadow-md"
            style={{
                borderBottom: '1px solid rgba(0, 0, 0, 0.06)',
            }}
        >
            <div>
                <div className="flex items-center gap-2">
                    {items.map((item) => (
                        <Button
                            key={item.label}
                            onClick={item.onClick}
                            className="border-purple-PHX text-purple-PHX flex items-center gap-2"
                            size="large"
                        >
                            {item.icon}

                            {item.label}
                        </Button>
                    ))}
                </div>

                {!isPreviewMode && (
                    <div className="font-semibold mt-2">
                        อัปเดตล่าสุด : {dsBreachDetail?.modifyDate || '-'}
                    </div>
                )}
            </div>

            {!isPreviewMode && (
                <Space>
                    <Button
                        loading={loading}
                        onClick={() => onFinish(false)}
                        name="save"
                        htmlType="submit"
                        size="large"
                        className="border-purple-PHX text-purple-PHX"
                    >
                        บันทึก
                    </Button>

                    <Button
                        name="publish"
                        onClick={() => setOpenConfirm(true)}
                        htmlType="submit"
                        size="large"
                        type="primary"
                    >
                        บันทึกและเผยแพร่
                    </Button>
                </Space>
            )}
        </div>
    );
};

// PropTypes
MenuBar.propTypes = {
    isPreviewMode: PropTypes.bool,
    setIsPreviewMode: PropTypes.func,
    setIsCustomize: PropTypes.func,
    state: PropTypes.object,
    dsBreachDetail: PropTypes.object,
    loading: PropTypes.bool,
    onFinish: PropTypes.func,
    setOpenConfirm: PropTypes.func,
};

export default MenuBar;
